var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{attrs:{"options":_vm.editorOption,"disabled":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }